import React, { forwardRef, useEffect, useRef, useState } from "react";
import { Button, Form, InputGroup, Modal } from "react-bootstrap";

let idx = 0;
const InputAddField = ({btnText="추가", template=<input className="form-control" />, defaultCreated=1, children, confirm, handleDelete=()=>{}, ...props}) => {
    const [inputs, setInputs] = useState(null);
    const [currentIdxForModal, setCurrentIdxForModal] = useState();
    const [showModal, setShowModal] = useState(false);

    const handleAddInput = () => {
        idx++;
        let init = {};
        init = {
            idx: idx,
            jsx: template,
        };
        setInputs([...inputs, init]);
    };

    const handleDeleteInput = (index) => {
        if (inputs.length > 1) {
            templateRefs.current.forEach(el => {
                if (el.idx == index) {
                    handleDelete(el.el.value);
                    const newArray = [...inputs];
                    const find = newArray.findIndex(item => item.idx === index);
                    newArray.splice(find, 1);
                    setInputs(newArray);
                }
                
            });
        }
    };

    const templateRefs = useRef([]);

    useEffect(() => {
        let init = [];
        let addedField = [];
        if (children) {
            if (children.length >= 1) {
                for (let i = 0; i < children.length; i++) {
                    idx++;
                    addedField.push({
                        idx: idx,
                        jsx: <InputAddField.Children val={children[i].props.val}>{children[i].props.children}</InputAddField.Children>,
                        isChildren: 1
                    })
                }
            } else { // 배열로 오지 않을 때 (1개)
                if (children.length != 0) { // 띄어쓰기 등 빈 값이 아닐 때
                    idx++;
                    addedField.push({
                        idx: idx,
                        jsx: <InputAddField.Children val={children.props.val}>{children.props.children}</InputAddField.Children>,
                        isChildren: 1
                    })
                }
            }
        }
        for (let i = 0; i < defaultCreated; i++) {
            idx++;
            init.push({
                idx: idx,
                jsx: template
            })
        }
        setInputs([...addedField, ...init]);

        templateRefs.current = [];
    },[]);

    return (
        <>
            <div className="d-flex flex-column gap-2">
            {
                inputs && 
                inputs.map((item,idx) => {
                    if (idx == 0) {
                        templateRefs.current = [];
                    }
                    const currentIdx = item['idx'];
                    return (<div className="d-flex gap-1" key={currentIdx}>
                        <InputGroup style={{width: "calc(100% - 16px)", flexShrink: "0"}}>
                            {
                                React.cloneElement(item['jsx'], {
                                    key: currentIdx,
                                    ref: el => {
                                        if (el) {
                                            templateRefs.current.push({
                                                idx: currentIdx, 
                                                el: el
                                            })
                                        }
                                    },
                                })
                            }
                        </InputGroup>

                        {(inputs.length > 1 && ((!item.isChildren && idx != 0) || item.isChildren == 1)) && (
                            <div style={{marginTop: "12px", cursor: "pointer"}} onClick={() => {
                                if (item.isChildren) {
                                    setShowModal(true);
                                    setCurrentIdxForModal(currentIdx);
                                } else {
                                    handleDeleteInput(currentIdx);
                                }
                            }}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                    <path fill="#ed4c78" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708"/>
                                </svg>
                            </div>
                        )}
                    </div>)
                })
            }
            </div>
            <Button variant="link" onClick={(e) => {
                handleAddInput();
            }}>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                    <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"/>
                </svg>
                {btnText}
            </Button>

            <Modal show={showModal} centered size="sm">
                <Modal.Body style={{lineHeight: 1.2}}>
                    {confirm}
                </Modal.Body>
                <Modal.Footer>
                <Button variant="secondary" onClick={() => {setShowModal(false)}}>
                    취소
                </Button>
                <Button variant="primary" onClick={() => {
                    handleDeleteInput(currentIdxForModal);
                    setShowModal(false);
                }}>
                    삭제
                </Button>
            </Modal.Footer>
            </Modal>
        </>
    )
}



const Children = forwardRef(({children, val}, ref) => {
    return (
        <div className="w-100">
            <Form.Control ref={ref} value={val} disabled />
            {children}
        </div>
    )
});

InputAddField.Children = Children;
export default InputAddField;